import React from 'react';
import styled from 'styled-components';
import { useImagesContext } from '../../../contexts/ImagesContext';
import SoulNumber from './SoulNumber';
import AnimationWithSound from '../AnimationWithSound';

export const BOSS_SOUL_STATE = {
  NOT_DISPLAYED: 0,
  NORMAL: 1,
  INCREASING: 2,
};

const BossSoul = ({ amount, state }) => {
  const { images } = useImagesContext();
  return (
    <Block $background={images['play-soul.png']}>
      {state === BOSS_SOUL_STATE.NORMAL && (
        <SoulNumber number={amount} top="60px" fontHeight="75px" />
      )}
      {state === BOSS_SOUL_STATE.INCREASING && (
        <AnimationWithSound
          imageUrl={images['play-boss-capture.png']}
          soundFile={null}
          style={{
            overflow: 'visible',
            width: 210,
            height: 175,
            right: 0,
            bottom: 0,
          }}
        />
      )}
    </Block>
  );
};

const SoulWhiteCapture = styled.img`
  position: absolute;
  right: 0;
  bottom: 0;
  overflow: visible;
`;

const Block = styled.div`
  position: absolute;
  top: 670px;
  right: 0px;
  width: 155px;
  height: 176px;
  background-image: url(${(props) => props.$background});
  background-size: cover;
  background-repeat: no-repeat;
`;
export default BossSoul;
